import {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from "react";
import { getCookie, setCookie, removeCookie } from "../global/functions/cookies";

const RestaurantContext = createContext();

export const RestaurantProvider = ({ children }) => {
  const [restaurantId, setRestaurantId] = useState(() => {
    return getCookie("restaurantId") || null;
  });

  const [restaurantName, setRestaurantName] = useState(() => {
    return getCookie("restaurantName") || "Default Restaurant";
  });

  const [restaurantLogo, setRestaurantLogo] = useState(() => {
    return getCookie("logo") || "default-logo.png";
  });

  const [currency, setCurrency] = useState(() => {
    return getCookie("currency") || "€";
  });

  useEffect(() => {
    if (restaurantId) {
      setCookie("restaurantId", restaurantId);
    } else {
      removeCookie("restaurantId");
    }
  }, [restaurantId]);

  useEffect(() => {
    if (restaurantName) {
      setCookie("restaurantName", restaurantName);
    } else {
      removeCookie("restaurantName");
    }
  }, [restaurantName]);

  useEffect(() => {
    if (restaurantLogo) {
      setCookie("logo", restaurantLogo);
    } else {
      removeCookie("logo");
    }
  }, [restaurantLogo]);

  useEffect(() => {
    if (currency) {
      setCookie("currency", currency);
    } else {
      removeCookie("currency");
    }
  }, [currency]);


  const value = useMemo(
    () => ({ restaurantId, setRestaurantId, restaurantName, setRestaurantName, restaurantLogo, setRestaurantLogo, currency, setCurrency }),
    [restaurantId, restaurantName, restaurantLogo, currency]
  );

  return (
    <RestaurantContext.Provider value={value}>
      {children}
    </RestaurantContext.Provider>
  );
};

export const useRestaurant = () => useContext(RestaurantContext);
